import { useEndpointTestTrend } from '@/hooks/useEndpointTestRunGroups';
import { trendDotClass } from '@/utils/testRunResults';

/**
 * A test's last five outcomes across test runs (task 1177), oldest left: a
 * solid red trend is a regression, alternating is flaky.
 */
export function TrendDots({ endpointTestId }: { endpointTestId: string }) {
  const { data } = useEndpointTestTrend(endpointTestId);
  const points = [...(data ?? [])].slice(0, 5).reverse();
  if (points.length === 0) return null;
  return (
    <span className="inline-flex items-center gap-0.5" data-testid="trend-dots" aria-label="Last five results">
      {points.map((point, index) => (
        <span
          key={`${point.endpointTestRunGroupId}-${index}`}
          title={point.outcome ?? 'no verdict'}
          className={`w-1.5 h-1.5 rounded-full ${trendDotClass(point.outcome)}`}
        />
      ))}
    </span>
  );
}

export default TrendDots;
